import { render, staticRenderFns } from "./EditDataTable.vue?vue&type=template&id=228382b9"
import script from "./EditDataTable.vue?vue&type=script&lang=js"
export * from "./EditDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports